module.exports = __webpack_public_path__ + "static/media/logo.0ca61cf6.png";